import React from 'react';
import {withRouter} from 'react-router';
import PropTypes from 'prop-types';
import {loadStripe} from '@stripe/stripe-js';
import {isNil} from 'ramda';
import styled from 'styled-components';
import {Header, Container, Message, Icon} from 'semantic-ui-react';
import {createDonationStripeSession, createTeamPayment, retrieveTeam} from '../../api';
import {getUserPropertyWithRefresh, madeTeamPayment} from '../../util/Session';
import {ButtonsGroup, GreenButton} from '../../components/Button/ButtonMix';
import {BlueContainer} from '../../components/Container/ContainerMix';
import MenuButton from '../../components/Button/MenuButton';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const Logo = styled.img`
  max-width: 205px;
`;

const Heading = styled.div`
  text-align: center;
  padding: 30px 0 10px;
  & > h1 {
    color: #ffffff;
  }
  & > p {
    color: #ffffff;
  }
`;


const FullHeightBlueContainer = styled(BlueContainer)`
  height: calc(100vh);
  overflow-y: auto;
`;

const PrecessedIcon = styled(Icon.Group)`
  margin: calc(30vh - 50px) auto 20px auto;
  color: #ffffff;
`;


class TeamDonations extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      team: null,
      success: false
    };
  }

  componentDidMount() {
    const {router} = this.props;
    const query = new URLSearchParams(window.location.search);

    return getUserPropertyWithRefresh('team_id')
      .then(teamId => retrieveTeam(teamId))
      .then(response => {
        this.setState({team: response.data});

        // This means the user just donated successfully! Record the payment in our system and redirect them
        // to the dashboard
        if (query.get('success')) {
          this.setState({success: true, message: 'Donation successful!'});

          const stripeCheckoutSessionId = query.get('session_id');

          // Make a payment, save in our Session this user made a payment, then let them go to the Dashboard!
          return createTeamPayment(this.state.team.id, stripeCheckoutSessionId)
            .then(() => madeTeamPayment())
            .then(() => router.push('/dashboard'));
        }

        // This means the user cancelled the payment from the Stripe screen. Just display a message.
        if (query.get('canceled')) {
          this.setState({message: 'Donation canceled.'});
        }
      });
  }

  handleDismiss = () => this.setState({ message: null });

  render() {
    const {team, message, success} = this.state;
    const {onClickSidebar} = this.props;

    const handleClick = () => stripePromise
      .then(stripe => createDonationStripeSession(team.id)
        .then(response => {
          const stripeCheckoutSessionId = response.data.id;
          return stripe.redirectToCheckout({sessionId: stripeCheckoutSessionId});
        }));

    // Payment was successful! Show loading while we redirect to the /dashboard
    if (success) {
      return (
        <FullHeightBlueContainer>
          <PrecessedIcon size="huge">
            <Icon loading size="big" name="circle notch" />
            <Icon name="check" />
          </PrecessedIcon>

          <Header as="h3" icon textAlign="center" style={{color: '#ffffff', marginTop: 'calc(100hv - 100px)'}}>
            <Header.Content>Donation successful!</Header.Content>
          </Header>
        </FullHeightBlueContainer>
      );
    }

    return !isNil(team) ?
      (
        <FullHeightBlueContainer>
          <MenuButton onClick={onClickSidebar}/>
          <Heading>
            <Logo src="/images/logotype-white.svg" alt="Logo"/>
          </Heading>
          <Header as="h3" textAlign="center" style={{color: '#ffffff', marginTop: '0', marginBottom: '20px'}}>
            <Header.Content>$2.50 Team Donation</Header.Content>
          </Header>
          <Container textAlign="center" style={{color: '#ffffff', marginBottom: '20px'}}>
            <p>To join Team {team.name}, please make a one-time <b>$2.50 donation + fees</b> to {team.school.name}.</p>
          </Container>
          {!isNil(message) ? (
            <Message 
              onDismiss={this.handleDismiss}
              header={message}
              negative
            />
) : 
              null}
          <ButtonsGroup>
            <GreenButton type="button" id="checkout-button" onClick={handleClick} fluid>Proceed to Checkout</GreenButton>
          </ButtonsGroup>
        </FullHeightBlueContainer>
      ) :
      null;
  }
}

TeamDonations.propTypes = {
  router: PropTypes.object.isRequired,
  onClickSidebar: PropTypes.func.isRequired
};

export default withRouter(TeamDonations);



// WEBPACK FOOTER //
// ./src/pages/Team/TeamDonations.js